const FoodForm = ({}) => {
	return <div>FoodForm</div>;
};
export default FoodForm;
